import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../seo";
import { slugify } from "../../utils/slugify";

const Landingpagecompliance = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Icon mapping function based on section title
  const getSectionIcon = (title) => {
    const iconMap = {
      "Set Up Policy Pages": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.1666 44.1666H13.25C9.00996 44.1666 5.58329 40.74 5.58329 36.5V13.25C5.58329 9.00996 9.00996 5.58329 13.25 5.58329H39.75C43.99 5.58329 47.4166 9.00996 47.4166 13.25V21.1666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 26.5L24.2917 30.9167L33.125 22.0833"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.75 30.9166C43.99 30.9166 47.4166 34.3433 47.4166 38.5833C47.4166 42.8233 43.99 46.25 39.75 46.25C35.51 46.25 32.0833 42.8233 32.0833 38.5833C32.0833 34.3433 35.51 30.9166 39.75 30.9166Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.75 34.4729V38.5833H43.8604"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Set Up Shipping and Tax Rules": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 17.6666V13.25C17.6666 9.00996 21.0933 5.58329 25.3333 5.58329H27.6666C31.9066 5.58329 35.3333 9.00996 35.3333 13.25V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 26.5H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 33.125H28.7083"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 39.75H26.5"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Configure Payment and Checkout Process": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.41663 22.0833H48.5833"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.125 35.3333C35.1012 35.3333 36.7083 33.7262 36.7083 31.75C36.7083 29.7738 35.1012 28.1666 33.125 28.1666C31.1488 28.1666 29.5416 29.7738 29.5416 31.75C29.5416 33.7262 31.1488 35.3333 33.125 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Customize Your Checkout Settings": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 13.25V9.9375C19.875 7.40167 21.9017 5.375 24.4375 5.375H28.5625C31.0983 5.375 33.125 7.40167 33.125 9.9375V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 23.1875H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 30.9166H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Launch Your Xpage Store": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 26.5H35.3333"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    };

    return (
      iconMap[title] || (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    );
  };

  const helpSections = [
    {
      title: "Store Compliance",
      description: "Ensure your landing page meets all compliance requirements",
      items: [
        {
          id: "landing-page-compliance",
          title: "Landing Page Compliance",
          description:
            "Ensure your landing page meets all compliance requirements and is ready to launch.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.1666 44.1666H13.25C9.00996 44.1666 5.58329 40.74 5.58329 36.5V13.25C5.58329 9.00996 9.00996 5.58329 13.25 5.58329H39.75C43.99 5.58329 47.4166 9.00996 47.4166 13.25V21.1666"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.875 26.5L24.2917 30.9167L33.125 22.0833"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M39.75 30.9166C43.99 30.9166 47.4166 34.3433 47.4166 38.5833C47.4166 42.8233 43.99 46.25 39.75 46.25C35.51 46.25 32.0833 42.8233 32.0833 38.5833C32.0833 34.3433 35.51 30.9166 39.75 30.9166Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M39.75 34.4729V38.5833H43.8604"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          sections: [
            {
              id: "Set Up Policy Pages",
              title: "Set Up Policy Pages",
              description:
                "Configure your policy pages including privacy policy, terms of service, and refund policy.",
            },
            {
              id: "Set Up Shipping and Tax Rules",
              title: "Set Up Shipping and Tax Rules",
              description:
                "Set up shipping zones, rates, and tax settings for your store.",
            },
            {
              id: "Configure Payment and Checkout Process",
              title: "Configure Payment and Checkout Process",
              description:
                "Configure payment methods and streamline the checkout process.",
            },
            {
              id: "Customize Your Checkout Settings",
              title: "Customize Your Checkout Settings",
              description:
                "Customize checkout fields, order confirmation, and thank you pages.",
            },
            {
              id: "Launch Your Xpage Store",
              title: "Launch Your Xpage Store",
              description: "Final steps to launch your store and go live.",
            },
          ],
        },
      ],
    },
  ];

  // Handle card click - use the exact section names from sidebar
  // Handle card click - update URL with section like sidebar (no slugs)
const handleCardClick = (itemId, sectionId) => {
  navigate(`/help/${slugify(itemId)}/${slugify(sectionId)}`);
};

  // Filter items based on search query
  const filteredSections = helpSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.sections.some(
            (sectionItem) =>
              sectionItem.title
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
              sectionItem.description
                .toLowerCase()
                .includes(searchQuery.toLowerCase()),
          ),
      ),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <div className="min-h-screen flex flex-col md:pt-10 pt-16">
      <SEO
        title="Landing Page Compliance – xPAGE Help Center"
        description="Ensure your landing page is compliant with all eCommerce standards. Learn how to set up policy pages, configure checkout, and launch your xPage store successfully."
        keywords="xPAGE, compliance, landing page, privacy policy, checkout setup, tax settings, shipping, online store"
        canonical="https://help.xpage.ai/help/landing-page-compliance/landing-page-compliance"
        type="article"
      />
      <div className="flex-1 w-full py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header with Description */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-systemTitle mb-3">
              Landing Page Compliance
            </h1>

            {/* Added description text */}
            <div className="mb-6">
              <p className="text-sm text-systemSubTitle leading-relaxed">
                Your landing page is ready to shine. With xPage, all your
                policies are automatically displayed in the header and footer,
                giving customers instant confidence. Double-check your products,
                shipping, payment, and tax settings, run a quick checkout test,
                and make sure your page looks perfect on every device. When
                everything checks out, hit Publish and turn your landing page
                into a fully compliant, high-converting storefront your
                customers can trust.
              </p>
            </div>
          </div>

          {/* Spacing between description and cards */}
          <div className="mb-6"></div>

          {/* Help Sections */}
          <div className="space-y-6">
            {filteredSections.map((section, sectionIndex) => (
              <div key={sectionIndex} className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {section.items.flatMap((item) =>
                    item.sections.map((sectionItem, sectionIndex) => (
                      <div
                        key={sectionIndex}
                        onClick={() => handleCardClick(item.id, sectionItem.id)}
                        className="group relative bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 cursor-pointer hover:border-systemLabel"
                      >
                        {/* Hover effect background */}
                        <div className="absolute inset-0 bg-gradient-to-br from-deepPurple/5 to-transparent opacity-0 group-hover:opacity-100 rounded-xl transition-opacity duration-300"></div>

                        <div className="relative z-10">
                          {/* Icon and Title */}
                          <div className="flex items-center space-x-3 mb-3">
                            <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center transition-colors duration-300 group-hover:bg-deepPurple/5">
                              {getSectionIcon(sectionItem.title)}
                            </div>
                            <h3 className="text-lg font-semibold text-systemTitle transition duration-300">
                              {sectionItem.title}
                            </h3>
                          </div>

                          {/* Section-specific description */}
                          <p className="text-sm text-systemLabel leading-relaxed transition-colors duration-300">
                            {sectionItem.description}
                          </p>

                          {/* Hover arrow indicator */}
                          <div className="absolute right-4 top-4 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                            <svg
                              className="w-7 h-7 text-base"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    )),
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landingpagecompliance;
